import get from 'lodash/get';
import { navianceSignInFailure, navianceCodeInSuccess, appRefreshed } from './containers/Authorization/actions';
import configureRedux from './configureRedux';

export default (userData, callback) => {
  configureRedux({}, async (store) => {
    if (userData) {
      if (userData.loginError || userData.stateMismatch || !userData.hasCode) {
        await store.dispatch(navianceSignInFailure());
      } else {
        await store.dispatch(navianceCodeInSuccess(userData));
      }
    } else {
      await store.dispatch(appRefreshed(get(store.getState(), 'current.viewer')));
    }
    callback(store);
  });
};
